import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportPokerNhleSdResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportPokerNhleSdInner() {
    return <PlayerLevelReportBase tab="pokerNhleSd" columnsSettingsViewType="PlayerLevelReportPokerNhleSd" />;
}

const PlayerLevelReportPokerNhleSdWithAccess = withAccessCheck(PlayerLevelReportPokerNhleSdInner, playerLevelReportPokerNhleSdResource);

export const PlayerLevelReportPokerNhleSd = withTraceErrorBoundary(PlayerLevelReportPokerNhleSdWithAccess, ErrorModal);
